import React from 'react'
import "./Login.css";
import { Button } from "@material-ui/core";
import { auth, provider } from "./firebase";
import { useStateValue } from "./StateProvider";
import { actionTypes } from "./reducer";

function Login() {
   const [state, dispatch] = useStateValue();

    const signIn = () => {
        auth.signInWithPopup(provider)
            .then((result) => {
                console.log(result);
                dispatch({
                    type: actionTypes.SET_USER,
                    user: result.user,
                });
            })
            .catch((error) => {
                alert(error.message);
            });
    };
//  <h1>MyTeam</h1>
    return (
        <div className="login" >
            <div className="login__container">
                <div>
                

                <img
                   // src="https://a.slack-edge.com/80588/marketing/img/icons/icon_slack_hash_colored.png"
                    src="my3.png"
                    alt=""
                />
                </div>
                <img
                   // src="https://a.slack-edge.com/80588/marketing/img/icons/icon_slack_hash_colored.png"
                    src="myteam.jpg"
                    alt=""
                /> 
                <h1>Sign in to MyTeam</h1>
                <h4>Created by Raviprakash Ram</h4>
                <Button onClick={signIn}>Sign in with Google</Button>
            
            </div>
        </div>
    )
}

export default Login
